

import React, { memo, useState } from 'react';
import cx from 'classnames';
import { EditorState } from 'draft-js';
import { Input, Button, Icon, LucideIcon } from '../../../../ui-kit';
import { Pencil, Trash2 } from 'lucide-react';
import RichTextEditor from '../../../RichTextEditor/components/RichTextEditor';
import AspectRatio from '../../../Addons/components/Dropdown/AspectRatio';

import '../../styles/_social-iteration-v2.scss';


















function SocialIterationV2({
  outputIndex,
  aspectRatio,
  onChangeAddon,
  notes,
  outputId,
  onNotesChange,
  name,
  updateOutputName,
  deleteOutput,
  canUpdateMaster,
  isMobile,
  isPodcast
}) {
  const [outputNotes, setOutputNotes] = useState(notes);

  const handleOutputNotesChange = (editorState) => {
    setOutputNotes(editorState);
  };

  return (
    <div className={cx(
      'social-iteration-v2',
      { mobile: isMobile }
    )}>

      <div className="social-iteration-v2__configure">
        <div className="social-iteration-v2__configure__header">
          <div className="social-iteration-v2__configure__header__fields">
            <Input
              placeholder="Iteration name"
              prefix={<LucideIcon icon={Pencil} size={15} />}
              className="social-iteration-v2__configure__header__fields__name"
              defaultValue={name || `Iteration ${outputIndex + 1}`}
              onChange={updateOutputName(outputId)}
              disabled={!canUpdateMaster} />

            {!isPodcast &&
            <AspectRatio
              onChangeAddon={onChangeAddon}
              aspectRatio={aspectRatio}
              label=""
              disabled={!canUpdateMaster} />}


          </div>
          {!isMobile &&

          <Button
            prefix={<LucideIcon icon={Trash2} size={20} />}
            onClick={deleteOutput}
            type="TERTIARY"
            disabled={!canUpdateMaster}
            className="remove-iteration" />}



        </div>
        <div className="editor-brief-section__notes social-iteration-v2__notes">
          <RichTextEditor
            label="Iteration Brief"
            editorState={outputNotes}
            onUpdateContent={handleOutputNotesChange}
            onBlur={() => onNotesChange(outputId, outputNotes)}
            placeholder={canUpdateMaster ?
            'Describe how your social iteration should differ from the master copy' :
            'Notes'}
            disabled={!canUpdateMaster}
            hideControls
            setFocusOnMount={false} />

        </div>
        <div className="social-iteration-v2__configure__footer">
          {isMobile &&

          <Button
            prefix={<LucideIcon icon={Trash2} size={20} />}
            onClick={deleteOutput}
            type="TERTIARY"
            disabled={!canUpdateMaster} />}



        </div>
      </div>
    </div>);

}

export default memo(SocialIterationV2);